import React, { useState } from "react";
import Modal from "../../../../components/ui/Modal/Modal";
import FactoryInventoryTable from "./FactoryInventoryTable";
import InventoryDetail from "./InventoryDetail";

function CheckFactoryInventory(props) {
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);

  React.useEffect(() => {
    if (triggerCloseModal === true) {
      setTriggerCloseModal(false);
    }
  }, [triggerCloseModal]);

  const handleClose = () => {
    setTriggerCloseModal(true);
  };

  return (
    <div className="my-1">
      <div className="flex mx-8 gap-3">
        <div className="flex flex-none gap-2 items-center border border-[#dddddd]">
          <div className="bg-[#f2f2f4] w-36 h-10 flex items-center px-3">
            최종 업데이트 일시
          </div>
          <div className="bg-white h-10 flex items-center px-3">
            <span>2023.01.31 23:59:59</span>
            <button className="rounded-[4px] border border-button-grey py-1 px-4 ml-4">
              새로고침
            </button>
          </div>
        </div>
        <Modal
          childrenWidth="w-full"
          hasCancel={false}
          hasSubmit={false}
          title="스마트팩토리 연동 등록"
          paddingTitle={`px-6`}
          padding="py-4"
          triggerClose={triggerCloseModal}
          rightTittle={
            <button
              onClick={handleClose}
              className="rounded-[4px] border border-[#cccccc] p-1 w-[5rem]"
            >
              닫기
            </button>
          }
          maxWidth="max-w-[68rem]"
          description={<InventoryDetail />}
        >
          <button className="bg-[#f2dca8] font-bold h-10 flex items-center justify-center w-full rounded-[4px] border border-[#cccccc] text-black">
            스마트팩토리 API - 일괄 재고 연동하기
          </button>
        </Modal>
      </div>
      <div className="border-t-[12px] mt-4 pb-4 border-line-grey "></div>
      <div className=" mx-8">
        <div className="bg-primary-blue p-3 w-full text-white">
          스마트팩토리 API 연동 데이터 정보
        </div>
        <FactoryInventoryTable />
      </div>
    </div>
  );
}

export default CheckFactoryInventory;
